var cmCarsCalendar = (function ($) {
    'use strict';
    return {
        objectName: 'cmCarsCalendar',
        depElm: null,
        destElm: null,
        date1Field: 'depDate',
        date2Field: 'destDate',
        timeField: '',
        divCal: '',
        dateField: '',
        dateDep: '',
        dateDest: '',
        shift: 0,
        dateNow: null,
        gCallerObj: '',
        monthNames: [],
        daysPerMonth: [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        dateSeperator: '.',
        lastCorrectDepDate: null,
        lastCorrectDestDate: null,
        lastParsedDate: null,
        oneDay: 1000 * 60 * 60 * 24,
        dep2DestInterval: 7,
        tabletOnIndex:
            $('#isTablet').val() === '1' && $('#isIndex').val() === '1',
        activeDayHighlighted: false,
        selectedDay: 0,
        selectedMonth: 0,
        selectedYear: 0,
        calculateTimespanWithTime: false,
        calAttribute: 'data-cal',
        dateAttribute: 'data-date',
        sourceAttribute: 'data-source',
        descriptionHeadline: false,

        init: function () {
            this.monthNames = js_tr.calendar.months;
            this.dateNow = this.getToday();
            this.depElm = $('#' + this.date1Field);
            this.destElm = $('#' + this.date2Field);
            var dep = this.depElm.length > 0 ? this.depElm.val() : '';
            var dest = this.destElm.length > 0 ? this.destElm.val() : '';
            var depValue = this.parseDate(dep);
            var destValue = this.parseDate(dest);
            this.lastCorrectDepDate = depValue ? depValue : this.dateNow;
            this.lastCorrectDestDate = destValue ? destValue : this.dateNow;
            this.dateSeperator =
                this.getSeperatorFromInitialDate() || this.dateSeperator;
            this.time.datetime = ApplicationProperties.get('datetime');

            if ($('#dep_time_in_past').length > 0) {
                $('#depDate').addClass('no-error');
            }

            // enable <select size="n"> + info text only for non-touch devices
            if (ApplicationProperties.get('touch') === false) {
                this.augmentTimeField();
            }
        },

        getToday: function () {
            return ApplicationProperties.get('actualServerDate') === false
                ? this.formatDate(new Date())
                : ApplicationProperties.get('actualServerDate');
        },

        getTodayAsDateObject: function () {
            return this.getDateObject(this.dateNow);
        },

        getDateObject: function (dateString) {
            dateString = this.parseDate(dateString);
            if (!dateString) {
                return null;
            }

            var regexp = /(\d+)(\D)(\d+)(\D)(\d+)(_(\d+)(\D)(\d+))?/;
            var result = dateString.match(regexp);

            if (
                result !== null &&
                result.length !== 6 &&
                result.length !== 10
            ) {
                return null;
            }
            var day = Number(result[1]);
            var month = Number(result[3]) - 1;
            var year = Number(result[5]);

            if (year < 100) {
                year += 2000;
            }

            if (
                result.length === 10 &&
                result[7] !== undefined &&
                result[9] !== undefined
            ) {
                var hour = Number(result[7]);
                var minute = Number(result[9]);
                return new Date(year, month, day, hour, minute);
            }

            return new Date(year, month, day);
        },

        showCal: function (source, div, shift_v) {
            this.shift = !shift_v ? 0 : shift_v;
            this.divCal = div;
            this.dateField = source;

            this.parseDataField(this.dateField);

            var date = null,
                thisday,
                thismonth,
                thisyear;
            var dateString = this.parseDate($('#' + this.dateField).val());

            if (false !== dateString) {
                var startDate = dateString;
                thisday = Number(startDate.substr(0, 2));
                thismonth = Number(startDate.substr(3, 2));
                thisyear = Number(startDate.substr(6, 4));
                if (thisyear < 100) {
                    thisyear += 2000;
                }
                date = startDate;
            } else {
                if (this.dateField === this.date1Field) {
                    // dep
                    date = this.lastCorrectDepDate;
                }

                if (this.dateField === this.date2Field) {
                    //dest
                    date = this.lastCorrectDestDate;
                }

                if (date === null) {
                    date = this.dateNow;
                }

                thisday = Number(date.substr(0, 2));
                thismonth = Number(date.substr(3, 2));
                thisyear = Number(date.substr(6, 4));
            }

            this.selectedDay = thisday;
            this.selectedMonth = thismonth;
            this.selectedYear = thisyear;

            var divCalElm = $('#' + this.divCal);

            if (divCalElm.hasClass('caldiv2')) {
                if (
                    this.dateField === this.date2Field &&
                    this.isDepCloseToNextMonth() &&
                    this.isDestInNextMonth(thismonth)
                ) {
                    thismonth--;
                }
            }

            if (this.dateField === this.date1Field) {
                //dep
                this.lastCorrectDepDate = date;
                this.dateDep = date;
                //if (divCalElm.hasClass("datetime")) {
                $('#depCalHolder').find('.arrow').show();
                //}
            }

            if (this.dateField === this.date2Field) {
                //dest
                this.lastCorrectDestDate = date;
                this.dateDest = date;
                //if (divCalElm.hasClass("datetime")) {
                $('#destCalHolder').find('.arrow').show();
                //}
            }

            if (this.dateDest === '') {
                var $destDate = $('#' + this.date2Field).val();
                this.dateDest = this.parseDate($destDate);
            }

            var m_month = '';
            if (this.shift > 0) {
                m_month = thismonth + this.shift;
                if (m_month / 12 > 1) {
                    thisyear += parseInt((m_month - 1) / 12, 10);
                }

                thismonth = m_month % 12;
            } else if (this.shift < 0) {
                //shift<0!
                m_month = thismonth + this.shift;
                if (m_month < 0) {
                    thismonth = (m_month % 12) + 12;
                } else {
                    thismonth = m_month;
                }

                if (m_month <= 0) {
                    thisyear -= -parseInt(m_month / 12, 10) + 1;
                }
            }

            if (thismonth <= 0) {
                thismonth = 12;
            }

            divCalElm.css('visibility', 'visible').show();

            var day = this.shift === 0 ? thisday : null;
            var firstMonth = this.getSingleCalendarSheet(
                this.dateField,
                this.divCal,
                day,
                thismonth,
                thisyear
            );

            divCalElm.html('');
            var sheet1 = $(document.createElement('div'))
                .addClass('sheet left')
                .html(firstMonth)
                .appendTo(divCalElm);

            if (this.descriptionHeadline) {
                sheet1.prepend('<h2>' + js_tr.calendar.choose_date + '</h2>');
            }

            if (divCalElm.hasClass('caldiv2')) {
                var nextSheetMonth = thismonth + 1;
                var nextSheetYear = thisyear;
                if (nextSheetMonth > 12) {
                    nextSheetMonth = 1;
                    nextSheetYear += 1;
                }

                var secondMonth = this.getSingleCalendarSheet(
                    this.dateField,
                    this.divCal,
                    day,
                    nextSheetMonth,
                    nextSheetYear
                );

                var sheet2 = $(document.createElement('div'))
                    .addClass('sheet right')
                    .html(secondMonth);

                sheet2.appendTo(divCalElm);
            }

            var thisdate = new Date(thisyear, thismonth - 1, thisday);
            var dateToday = this.getBarrierDate(this.dateField);
            var leftHandleActive =
                dateToday.getYear() < thisdate.getYear() ||
                (dateToday.getYear() === thisdate.getYear() &&
                    dateToday.getMonth() < thisdate.getMonth());
            var shiftL = this.shift - 1;

            var leftHandle = this.getHandle(
                'callinkl',
                leftHandleActive,
                this.dateField,
                shiftL,
                'left'
            );
            leftHandle.appendTo(divCalElm);

            var shiftR = this.shift + 1;

            var rightHandle = this.getHandle(
                'callinkr',
                true,
                this.dateField,
                shiftR,
                'right'
            );
            rightHandle.appendTo(divCalElm);

            var timespanHolder = $(document.createElement('span'))
                .attr('id', 'timespanHolder' + this.divCal)
                .addClass('timespan-holder')
                .html('')
                .appendTo(divCalElm);

            if (!shift_v && navigator.appName !== 'Opera') {
                document.getElementById(this.dateField).select();
            }

            this.setEvents();

            this.handleTimespan(this.dateDep, this.dateDest);
        },

        setEvents: function () {
            var self = this;

            $('.calholder')
                .off()
                .on('click', 'td.dateTrigger', function () {
                    var elm = $(this);
                    var data = elm.data();
                    var cal = elm.attr(self.calAttribute);
                    var date = elm.attr(self.dateAttribute);
                    var source = elm.attr(self.sourceAttribute);

                    if (data !== undefined) {
                        cal = data.cal;
                        date = data.date;
                        source = data.source;
                    }

                    self.setDate(source, cal, date);
                })
                .on('mouseenter', 'td.dateTrigger', function () {
                    var $this = $(this);
                    var data = $this.data();
                    var date = data.date;
                    self.handleTimespan(self.dateDep, date);
                    if (
                        self.divCal === 'cal2' &&
                        !$('#' + self.divCal).hasClass('datetime')
                    ) {
                        var className = 'selected-date';
                        $('.' + className).removeClass(className);
                        $this.find('span').addClass(className);
                    }
                })
                .on('mouseleave', 'td.dateTrigger', function () {
                    self.handleTimespan(self.dateDep, self.dateDest);
                });
        },

        handleTimespan: function (depDate, destDate) {
            this.setTimespan(depDate, destDate);
            if (this.divCal === 'cal2') {
                this.showTimespan();
                this.highlightDays(
                    this.getDateObject(depDate),
                    this.getDateObject(destDate)
                );
            }
        },

        setTimespan: function (depDate, destDate) {
            var depDateCalc = depDate;
            var destDateCalc = destDate;

            if (this.calculateTimespanWithTime) {
                var depTime = $('#depTime').val();
                var destTime = $('#destTime').val();
                if (depDate === destDate) {
                    depTime = '10:00';
                    destTime = '17:00';
                }
                depDateCalc += '_' + depTime;
                destDateCalc += '_' + destTime;
            }

            try {
                var $depDate = this.getDateObject(depDateCalc).getTime();
                var $destDate = this.getDateObject(destDateCalc).getTime();

                var difference = $destDate - $depDate;
                var timespan = Math.ceil(difference / this.oneDay) + 1;
                this.timespan = timespan > 0 ? timespan : 0;
            } catch (e) {
                this.timespan = 0;
            }
        },

        showTimespan: function () {
            var timespanHolder = $('#timespanHolder' + this.divCal);
            if (this.timespan > 0) {
                var translation =
                    this.timespan === 1
                        ? js_tr.calendar.day
                        : js_tr.calendar.days;
                timespanHolder.html(this.timespan + ' ' + translation).show();
            } else {
                timespanHolder.hide();
            }
        },

        highlightDays: function (from, to) {
            var className = 'highlighted';

            $('#' + this.divCal + ' .' + className).removeClass(className);

            var highlightList = [];
            var currentDate = from;
            while (currentDate <= to) {
                highlightList.push('#' + this.getIdFromDate(currentDate));
                currentDate = currentDate.addDays(1);
            }

            var selector = highlightList.join();

            $(selector).addClass(className);
        },

        getIdFromDate: function (date) {
            var dateString = this.formatDate(date);
            date = this.parseDate(dateString);
            return 'calField' + date.replace(/\D/g, '');
        },

        getHandle: function (
            identifier,
            handleActive,
            source,
            shift,
            direction
        ) {
            var self = this;

            var handle = $(document.createElement('div'))
                .addClass(identifier)
                .attr('id', identifier);

            handle.addClass('clr-wht bgc-grn fsi-12 pdg-2');

            if (handleActive) {
                handle.on('click', function () {
                    self.showCal(source, self.divCal, shift);
                });
            } else {
                handle.addClass('deactive bgc-gry-lgt-2');
            }

            return handle;
        },

        // returns the date, whose earlier dates should not be selectable on a calendar sheet
        // this is the actual date, or if available, the dep date
        getBarrierDate: function (source) {
            if (source !== 'depDate') {
                var depString = this.parseDate(this.depElm.val());
                if (depString) {
                    return this.getDateObject(depString);
                }
            }

            return this.getTodayAsDateObject();
        },

        getSingleCalendarSheet: function (
            source,
            divCal,
            thisday,
            thismonth,
            thisyear
        ) {
            var nDate = this.getBarrierDate(source);
            var nday = nDate.getDate();
            var nmonth = Number(nDate.getMonth()) + 1;
            var nyear = Number(nDate.getYear());
            nyear = nyear % 100;
            nyear = nyear < 50 ? 2000 + nyear : 1900 + nyear;
            var nowDay = nyear === thisyear && nmonth === thismonth ? nday : 0;
            var monthDays = this.daysPerMonth[thismonth];
            var offset = this.shift === 0 ? 1 : 0;
            var myDate = new Date(thisyear, thismonth - offset, thisday);
            myDate.setDate(1);

            /**
             * if Date object has set to next month
             * because thisday is not in thismonth (i.e. 30. Febr)
             * then subtract one month
             */
            if (myDate.getMonth() - thismonth === 0) {
                myDate = new Date(thisyear, myDate.getMonth() - 1, 1);
            }

            var startspaces = myDate.getDay() - 1 < 0 ? 6 : myDate.getDay() - 1;

            // check for february in leap year
            if (thismonth === 2 && this.isLeapYear(thisyear)) {
                monthDays = 29;
            }

            var content =
                '<table width="100%" class="cal">' +
                '<tr><th colspan="7" class="calmonth">' +
                this.monthNames[thismonth] +
                '&nbsp;' +
                thisyear +
                '</th></tr>' +
                '<tr class="calDays">' +
                js_tr.calendar.daysHeader +
                '<tr>';

            for (var s = 0; s < startspaces; s++) {
                content += '<td> </td>';
            }

            var count = 1;
            var showDay = '';
            while (count <= monthDays) {
                for (var b = startspaces; b < 7; b++) {
                    showDay = count.toString();
                    if (count <= monthDays) {
                        if (count < 10) {
                            showDay = '0' + showDay;
                        }
                        var showMonth = '';
                        if (thismonth < 10) {
                            showMonth = '0' + String(thismonth);
                        } else {
                            showMonth = thismonth;
                        }
                        if (count < nowDay) {
                            content += '<td class="caltdold"><span>';
                            content += count + '</span></td>';
                        } else {
                            var date =
                                showDay + '.' + showMonth + '.' + thisyear;
                            var dataDate =
                                this.dateAttribute + '="' + date + '"';
                            var dataSource =
                                this.sourceAttribute + '="' + source + '"';
                            var dataCal =
                                this.calAttribute + '="' + divCal + '"';
                            var addClass = 'class="';

                            if (
                                count === this.selectedDay &&
                                thismonth === this.selectedMonth &&
                                thisyear === this.selectedYear
                            ) {
                                addClass += 'selected-date ';
                            }

                            if (date === this.dateDep) {
                                addClass += 'current-dep';
                            } else if (date === this.dateDest) {
                                addClass += 'current-dest';
                            }

                            addClass += '"';
                            content +=
                                '<td id="' +
                                this.getIdFromDate(date) +
                                '" class="dateTrigger" ' +
                                dataDate +
                                ' ' +
                                dataSource +
                                ' ' +
                                dataCal +
                                '>';
                            content +=
                                '<span ' +
                                addClass +
                                ' >' +
                                showDay +
                                '</span>';
                            content += '</td>';
                        }
                    } else {
                        content += '<td> </td>';
                    }
                    count++;
                }
                content += '</tr><tr>';
                startspaces = 0;
            }
            content += '</table>';

            return content;
        },

        isDepCloseToNextMonth: function () {
            var depMonth;
            var depDay;
            var monthDays;

            try {
                depMonth = Number(
                    this.parseDate(this.depElm.val()).substr(3, 2)
                );
                depDay = Number(this.parseDate(this.depElm.val()).substr(0, 2));
                monthDays = this.daysPerMonth[depMonth];
            } catch (e) {
                depMonth = Number(
                    this.parseDate(this.lastCorrectDepDate).substr(3, 2)
                );
                depDay = Number(
                    this.parseDate(this.lastCorrectDepDate).substr(0, 2)
                );
                monthDays = this.daysPerMonth[depMonth];
            }
            return depDay + this.dep2DestInterval >= monthDays;
        },

        isDestInNextMonth: function (destMonth) {
            var depMonth = Number(
                this.parseDate(this.depElm.val()).substr(3, 2)
            );
            return destMonth > depMonth;
        },

        addInterval: function (date) {
            if (!date) {
                return this.dateNow;
            }

            var sday = Number(date.substr(0, 2));
            var smonth = Number(date.substr(3, 2));
            var syear = Number(date.substr(6, 4));
            var monthDays = this.daysPerMonth[smonth];

            if (syear < 100) {
                syear += 2000;
            }

            // check for february in leap year
            if (smonth === 2 && this.isLeapYear(syear)) {
                monthDays = 29;
            }

            if (sday + this.dep2DestInterval > monthDays) {
                sday = sday + this.dep2DestInterval - monthDays;
                smonth += 1;
                if (smonth === 13) {
                    smonth = 1;
                    syear += 1;
                }
            } else {
                sday += this.dep2DestInterval;
            }

            if (sday < 10) {
                sday = '0' + sday;
            }

            if (smonth < 10) {
                smonth = '0' + smonth;
            }

            var ret = sday + '.' + smonth + '.' + syear;
            return ret.replace(/\./g, this.dateSeperator);
        },

        setDate: function (source, divCal, date) {
            date = this.parseDate(date.replace(/\./g, this.dateSeperator));

            var depTime = '';
            var destTime = '';

            if ($('#' + divCal).hasClass('datetime')) {
                depTime = this.time.parseTime('depDate');
                destTime = this.time.parseTime('destDate');
            }

            if (this.dateDep === '' || this.dateDest === '') {
                this.dateDep = this.parseDate(this.depElm.val());
                this.dateDest = this.parseDate(this.destElm.val());
            }

            //dep
            if (source === this.date1Field) {
                this.dateDep = date;
                this.dateDest = this.dateok(this.dateDep, this.dateDest)
                    ? this.dateDest
                    : this.addInterval(date);
                $('#' + source).val(this.formatDate(date, depTime));
                if (this.tabletOnIndex) {
                    setTimeout('jQuery("#depTime").trigger("focus")', 100);
                }
            }

            //dest
            if (source === this.date2Field) {
                this.dateDest = date;
                if (this.tabletOnIndex) {
                    setTimeout('jQuery("#destTime").trigger("focus")', 100);
                }
            }

            this.destElm.val(this.formatDate(this.dateDest, destTime));

            if ($('#' + divCal).hasClass('datetime')) {
                $('#' + divCal)
                    .find('.selected-date')
                    .removeClass('selected-date');
                $('#' + this.getIdFromDate(date) + ' span').addClass(
                    'selected-date'
                );
            } else {
                this.gCallerObj.gotoNext(source);
            }

            this.time.checkTimeForSingleDay();
        },

        formatDate: function (date, time) {
            if (typeof date !== 'object') {
                date = this.getDateObject(date);
            }

            if (!date) {
                date = new Date();
            }

            var thisday = Number(date.getDate());
            var thismonth = Number(date.getMonth()) + 1;
            var thisyear = Number(date.getYear());

            thisyear = thisyear % 100;
            thisyear = thisyear < 50 ? 2000 + thisyear : 1900 + thisyear;

            if (thisday < 10) {
                thisday = '0' + thisday;
            }

            if (thismonth < 10) {
                thismonth = '0' + thismonth;
            }

            var day = date.getDay();
            var thistime = '';

            if (time) {
                thistime = ' - ' + time;
            }

            var dateString =
                js_tr.calendar.shortDays[day] +
                ', ' +
                thisday +
                '.' +
                thismonth +
                '.' +
                thisyear +
                thistime;

            return dateString.replace(/\./g, this.dateSeperator);
        },

        parseDate: function (date) {
            date = String(date);
            date = date.replace(/[A-Za-z\s,]/g, '');
            date = date.replace(/-[0-9:]*/g, '');

            if (date.length > 16) {
                return false;
            }

            var regexp = /(\d+)(\D)(\d+)(\D)(\d+)(_(\d+)(\D)(\d+))?/;
            var result = date.match(regexp);

            if (
                result !== null &&
                result.length !== 6 &&
                result.length !== 10
            ) {
                return false;
            }

            var thisday, thismonth, thisyear, monthDays;

            if (result === null) {
                thisday = 0;
                thismonth = 0;
                thisyear = 0;
                if (typeof this.sf !== 'undefined') {
                    this.sf.errors.show(this.dateField);
                }
            } else {
                thisday = Number(result[1]) || 0;
                thismonth = Number(result[3]) || 0;
                thisyear = Number(result[5]) || 0;
            }

            monthDays = this.daysPerMonth[thismonth];

            if (thisyear < 100) {
                thisyear += 2000;
            }

            if (!thisday || !thismonth || !thisyear) {
                return false;
            }

            // check for february in leap year
            if (thismonth === 2 && this.isLeapYear(thisyear)) {
                monthDays = 29;
            }

            if (
                thisday > monthDays ||
                thismonth < 1 ||
                thismonth > 12 ||
                thisday < 1 ||
                thisday > 31
            ) {
                return false;
            }
            return date;
        },

        parseDataField: function (field) {
            var $elm = $('#' + field);
            if (!$elm.length) {
                return;
            }
            var date = $elm.val();
            var parsedDate = this.parseDate(date);

            if (false === parsedDate) {
                if (field === this.date1Field) {
                    //dep
                    $elm.val(this.lastCorrectDepDate);
                    parsedDate = this.parseDate(this.lastCorrectDepDate);
                }

                if (field === this.date2Field) {
                    //dest
                    $elm.val(this.lastCorrectDestDate);
                    parsedDate = this.parseDate(this.lastCorrectDestDate);
                }
            }
            var parsedTime = this.time.parseTime(field);
            var y, m, d;

            //not as 15.10.2007
            if (false === parsedDate) {
                date = date.replace(/,/g, '.');
                date = date.replace(/-/g, '.');
                date = date.replace(/\s/g, '');

                //1.1.09 oder 31.12.9
                if (date.match(/.*\..*/) !== null) {
                    var temp = date.split('.');
                    d = Number(temp[0]);
                    m = Number(temp[1]);
                    y = temp[2];

                    if (d.toString().length === 1) {
                        d = '0' + d;
                    }
                    if (m.toString().length === 1) {
                        m = '0' + m;
                    }
                    if (y.toString().length === 2) {
                        y = '20' + y;
                    } else if (y.toString().length === 1) {
                        y = '200' + y;
                    }
                    if (false === this.parseDate(d + '.' + m + '.' + y)) {
                        parsedDate = 0;
                    } else {
                        parsedDate = d + '.' + m + '.' + y;
                    }

                    //30052007, 30.05.07
                } else if (date.length === 8) {
                    d = date.substr(0, 2);
                    m = date.substr(2, 2);
                    y = date.substr(4, 4);

                    //try 30.05.07,30-05-07
                    if (false === this.parseDate(d + '.' + m + '.' + y)) {
                        d = date.substr(0, 2);
                        m = date.substr(3, 2);
                        y = date.substr(6, 2);
                        y = '20' + y;
                        if (false !== this.parseDate(d + '.' + m + '.' + y)) {
                            parsedDate = d + '.' + m + '.' + y;
                        }
                    } else {
                        parsedDate = d + '.' + m + '.' + y;
                    }
                    //300507
                } else if (date.length === 6) {
                    d = date.substr(0, 2);
                    m = date.substr(2, 2);
                    y = date.substr(4, 2);
                    y = '20' + y;
                    if (false === this.parseDate(d + '.' + m + '.' + y)) {
                        parsedDate = 0;
                    } else {
                        parsedDate = d + '.' + m + '.' + y;
                    }
                } else if (date.length === 10) {
                    //2007-05-30
                    y = date.substr(0, 4);
                    m = date.substr(5, 2);
                    d = date.substr(8, 2);
                    if (false !== this.parseDate(d + '.' + m + '.' + y)) {
                        parsedDate = d + '.' + m + '.' + y;
                    }
                } else {
                    parsedDate = 0;
                }

                if (parsedDate !== 0) {
                    parsedDate = this.formatDate(parsedDate, parsedTime);
                    $elm.val(parsedDate);
                }
            }

            if (parsedDate !== 0 && parsedDate !== false) {
                $elm.val(this.formatDate(parsedDate, parsedTime));
                if (field === this.date1Field) {
                    this.dateDep = parsedDate;
                } else if (field === this.date2Field) {
                    this.testPeriod();
                }
            }

            if (
                field === this.date1Field &&
                $('#' + this.date1Field)
                    .parent()
                    .hasClass('error')
            ) {
                this.depElm.val(this.dateNow);
                $('#' + this.date1Field)
                    .parent()
                    .removeClass('error');
            } else if (
                field === this.date2Field &&
                $('#' + this.date2Field)
                    .parent()
                    .hasClass('error')
            ) {
                this.destElm.val(
                    this.formatDate(
                        this.addInterval(this.parseDate(this.dateNow)),
                        parsedTime
                    )
                );
                $('#' + this.date2Field)
                    .parent()
                    .removeClass('error');
            }

            if (field === this.date1Field) {
                this.depElm.val(this.formatDate(this.depElm.val(), parsedTime));
            } else if (field === this.date2Field) {
                this.destElm.val(
                    this.formatDate(this.destElm.val(), parsedTime)
                );
            }

            this.lastParsedDate = parsedDate;
            if (typeof this.sf !== 'undefined') {
                this.sf.errors.hide(this.dateField);
            }
            //this.time.checkTimeForSingleDay();
        },

        testPeriod: function () {
            this.dateDep = this.parseDate(this.depElm.val());
            this.dateDest = this.parseDate(this.destElm.val());

            if (false === this.dateok(this.dateNow, this.dateDest)) {
                this.destElm.val(this.dateDest);
            }
        },

        dateok: function (dateDep, dateDest) {
            if (!dateDep || !dateDest) {
                return false;
            }

            var depday = Number(dateDep.substr(0, 2));
            var depmonth = Number(dateDep.substr(3, 2));
            var depyear = Number(dateDep.substr(6, 4));
            var destday = Number(dateDest.substr(0, 2));
            var destmonth = Number(dateDest.substr(3, 2));
            var destyear = Number(dateDest.substr(6, 4));

            if (destyear < depyear) {
                return false;
            }
            if (destyear === depyear && destmonth < depmonth) {
                return false;
            }
            if (
                destyear === depyear &&
                destmonth === depmonth &&
                destday < depday
            ) {
                return false;
            }
            return true;
        },

        setCaller: function (obj) {
            this.gCallerObj = obj;
        },

        getSeperatorFromInitialDate: function () {
            return this.lastCorrectDepDate.match(/[^0-9]/);
        },

        isLeapYear: function (year) {
            return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
        },

        time: {
            timeField: '',
            datetime: false,
            formerDepTime: '12:00',
            formerDestTime: '09:00',

            generateDateTime: function (input) {
                $('#' + input)
                    .parent()
                    .find('.error-msg')
                    .hide();

                var selectedTime = $('#' + input).val();
                this.timeField = input;

                if (input === 'depTime') {
                    this.formerDepTime = selectedTime;
                } else if (input === 'destTime') {
                    this.formerDestTime = selectedTime;
                }
            },

            generateTimeSelect: function (input, div) {
                $('#depDateP').removeClass('error');
                $('#destDateP').removeClass('error');

                var selectedTime = $('#' + input).val();
                this.timeField = input;

                if (input === 'depTime') {
                    this.formerDepTime = selectedTime;
                } else if (input === 'destTime') {
                    this.formerDestTime = selectedTime;
                }
            },

            showTime: function (input, div) {
                $('#' + input).select();

                this.generateTimeSelect(input, div);
            },

            rewriteTime: function (sid, goNext) {
                var inputField = sid.substr(3, sid.length);
                var inputObj = $('#' + inputField);
                var selectObj = $('#' + sid);

                inputObj.val(selectObj.val());
                if (goNext === 1) {
                    cmCarsCalendar.gCallerObj.gotoNext(inputField);
                }

                if (inputField === 'depTime' && cmCarsCalendar.tabletOnIndex) {
                    setTimeout(
                        'jQuery("#" + cmCarsCalendar.date2Field).trigger("focus")',
                        100
                    );
                }
            },

            parseTime: function (id) {
                if (!this.datetime) {
                    return;
                }
                if (id === 'depDate') {
                    this.parseTimeField('depTime');
                    return this.formerDepTime;
                } else if (id === 'destDate') {
                    this.parseTimeField('destTime');
                    return this.formerDestTime;
                }
            },

            parseTimeField: function (id) {
                var time2parse = $('#' + id).val();
                time2parse = time2parse.replace(/[A-Za-z\s,\/0-9]* - /g, '');
                var hour = Number(time2parse.substr(0, 2));
                var min = Number(time2parse.substr(3, 4));

                if (
                    time2parse.search(/\d{2}[:|,|.]\d{2}$/) === -1 ||
                    hour < 0 ||
                    hour > 23 ||
                    min < 0 ||
                    min > 59
                ) {
                    return;
                }

                if (id === 'depTime' || id === 'depDate') {
                    this.formerDepTime = time2parse;
                } else if (id === 'destTime' || id === 'destDate') {
                    this.formerDestTime = time2parse;
                }
            },

            checkTimeForSingleDay: function () {
                var $elmDepTime = $('#depTime');
                var $elmDestTime = $('#destTime');
                var depTimeString = $elmDepTime.val() || '';
                var destTimeString = $elmDestTime.val() || '';
                var depTime = depTimeString.replace(/:/, '');
                var destTime = destTimeString.replace(/:/, '');
                var depDate = (cmCarsCalendar.depElm.val() || '').replace(
                    / - [0-9\:]*/g,
                    ''
                );
                var destDate = (cmCarsCalendar.destElm.val() || '').replace(
                    / - [0-9\:]*/g,
                    ''
                );

                if (depDate === destDate) {
                    if (parseInt(depTime, 10) >= parseInt(destTime, 10)) {
                        this.formerDepTime = depTimeString;
                        this.formerDestTime = destTimeString;
                        $elmDepTime.val('10:00');
                        cmCarsCalendar.parseDataField('depDate');
                        $elmDestTime.val('17:00');
                        cmCarsCalendar.parseDataField('destDate');
                    }
                }
            },
        },

        augmentTimeField: function () {
            var $elmDepTime = $('#depTime[aria-describedby]');
            var $elmDestTime = $('#destTime[aria-describedby]');
            var timeSelectOpen = false;

            function hideAllPopovers() {
                $('.inputTimePopover').attr('aria-hidden', 'true');
                timeSelectOpen = false;
            }

            function setValue($elm, value) {
                $elm.text(value);
            }

            function addMarkup($elm) {
                var value = $elm.val();
                var $description = $('#' + $elm.attr('aria-describedby'));
                $elm.attr('size', '10');
                $elm.wrap(
                    '<span class="inputTimeWrapper">' +
                        '<span class="inputTimePopover" role="dialog" aria-label="' +
                        js_tr.calendar.time_popover +
                        '" aria-hidden="true"/>' +
                        '</span>'
                );
                $elm.parent().before(
                    '<button type="button" class="inputTimeValue">' +
                        value +
                        '</button>'
                );
                if ($description.length !== 0) {
                    $description.prependTo($elm.parent());
                    $description.removeClass('hide');
                }
            }

            if ($elmDepTime.length > 0) {
                addMarkup($elmDepTime);
            }
            if ($elmDestTime.length > 0) {
                addMarkup($elmDestTime);
            }

            if ($elmDepTime.length > 0 || $elmDestTime.length > 0) {
                $(document).on('click', '.inputTimeValue', function (e) {
                    e.stopPropagation();
                    hideAllPopovers();
                    // show popover
                    $(this).next().attr('aria-hidden', 'false');
                    timeSelectOpen = true;
                    // scroll to selected option and focus element
                    var $select = $(this).next().find('.inputTime');
                    var optionTop = $select
                        .find('option:selected')
                        .offset().top;
                    var selectTop = $select.offset().top;
                    $select.scrollTop(
                        $select.scrollTop() + (optionTop - selectTop)
                    );
                    $select.trigger('focus');
                });

                $(document).on('change', '.inputTime', function () {
                    var value = $(this).val();
                    var $popover = $(this).parent();
                    setValue($popover.prev(), value);
                    hideAllPopovers();
                });

                $(document).on('click', function () {
                    if (timeSelectOpen) {
                        hideAllPopovers();
                    }
                });

                $(document).on('keyup', function (e) {
                    if (e.keyCode === 27 && timeSelectOpen) {
                        hideAllPopovers();
                    }
                });
            }
        },
    };
})(jQuery);
